import { createSidecarMedium } from '../../../use-sidecar/dist/es2015/medium.js';

var effectCar = createSidecarMedium();

export { effectCar };
